import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountupTimerComponent } from './countup-timer/countup-timer.component';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { CountupTimerService } from './countup-timer/countup-timer.service';
import { CountdownTimerService } from './countdown-timer/countdown-timer.service';

@NgModule({
	imports: [CommonModule],
	declarations: [CountupTimerComponent, CountdownTimerComponent],
	exports: [CountupTimerComponent, CountdownTimerComponent],
	providers: [CountupTimerService, CountdownTimerService]
})
export class AhsTimerModule {}
